var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckApprove = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.8667 10.6036L3.53336 8.27025C3.41013 8.14548 3.24206 8.07526 3.0667 8.07526C2.89133 8.07526 2.72327 8.14548 2.60003 8.27025C2.34003 8.53025 2.34003 8.94358 2.60003 9.20358L5.39336 11.9969C5.65336 12.2569 6.07336 12.2569 6.33336 11.9969L13.4 4.93692C13.66 4.67692 13.66 4.26358 13.4 4.00358C13.2768 3.87882 13.1087 3.80859 12.9334 3.80859C12.758 3.80859 12.5899 3.87882 12.4667 4.00358L5.8667 10.6036Z",
  fill: "#079D56"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckApprove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-approve.73dce022e829bd73c1b0ebd92ee9be03.svg";